function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var isObject = function isObject(obj) {
  return obj && _typeof(obj) === "object";
};
var deepClone = function deepClone(o) {
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var out = Array.isArray(o) ? [] : {};
  if (!isObject(o)) return out;
  Object.keys(o).forEach(function (key) {
    if (exclude.length > 0 && exclude.indexOf(key) !== -1) return;
    var v = o[key];
    out[key] = isObject(v) ? deepClone(v) : v;
  });
  return out;
};
var deepMerge = function deepMerge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (prev, obj) {
    Object.keys(obj).forEach(function (key) {
      var pVal = prev[key];
      var oVal = obj[key];
      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = [].concat(_toConsumableArray(pVal), _toConsumableArray(oVal)).filter(function (element, index, array) {
          return array.indexOf(element) === index;
        });
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = deepMerge(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });
    return prev;
  }, {});
};
var deepCompare = function deepCompare(obj1, obj2) {
  var isEqual = true;
  if (obj2 === undefined) return false;
  Object.keys(obj1).forEach(function (p) {
    switch (_typeof(obj1[p])) {
      case 'object':
        if (!deepCompare(obj1[p], obj2[p])) isEqual = false;
        break;
      default:
        if (obj1[p] !== obj2[p]) isEqual = false;
    }
  });
  Object.keys(obj2).forEach(function (p) {
    if (typeof obj1[p] === 'undefined') isEqual = false;
  });
  return isEqual;
};
export { deepClone, deepMerge, deepCompare };


// WEBPACK FOOTER //
// ./scripts/util/object.js